import { list } from 'src/app/common/classes/request-builder';
import { TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { ComunidadesRegantesModel } from 'src/app/models/analisis/comunidadesRegantes.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';

export class PlanAbonadoListsDefinition {
    public cultivos_precedentes: TypeAheadInterface<VisitasVariedadMesModel> = list(['...', null]);
    
    public cultivos: TypeAheadInterface<VisitasVariedadMesModel> = list(['...', null]);
        
    public comunidadesRegantes: TypeAheadInterface<ComunidadesRegantesModel> = list();
}